import React from "react";
import { useHistory } from "react-router-dom";
import ThemeDefaultComponent from "../../components/ThemeDefaultComponent/ThemeDefaultComponent";
import VerifikasiEmailAction from "./components/VerifikasiEmailAction";
import VerifikasiEmailContent from "./components/VerifikasiEmailContent";
import VerifikasiEmailHero from "./components/VerifikasiEmailHero";
import VerifikasiEmailPageLayout from "./components/VerifikasiEmailPageLayout";

const VerifikasiEmailPage = () => {
    const history = useHistory();

    return (
        <ThemeDefaultComponent>
            <VerifikasiEmailPageLayout>
                <VerifikasiEmailHero />
                <VerifikasiEmailContent />
                <VerifikasiEmailAction onBackToLogin={() => history.push("/")} />
            </VerifikasiEmailPageLayout>
        </ThemeDefaultComponent>
    );
};

export default VerifikasiEmailPage;
